var map = {
	"./aiIcon-animalDetect.svg": "5021",
	"./aiIcon-asr-rt.svg": "fa44",
	"./aiIcon-asr.svg": "5853",
	"./aiIcon-faceCompare.svg": "711b",
	"./aiIcon-faceSearch.svg": "a460",
	"./aiIcon-fr.svg": "92ab",
	"./aiIcon-lpr.svg": "47b7",
	"./aiIcon-ocr.svg": "509a",
	"./aiIcon-plantDetect.svg": "66e6",
	"./aiIcon-translate.svg": "a323",
	"./aiIcon-ttr.svg": "25aa",
	"./aiIcon-tts.svg": "4992"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3677";